import React, { useEffect, useState, useCallback, useRef } from "react";
import axios from "axios";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cookies from "js-cookie";
import Hero from "../components/Hero";

import {
  FaTshirt,
  FaGamepad,
  FaPaw,
  FaCar,
  FaMoneyBillWave,
  FaHome,
  FaMobileAlt,
  FaCouch,
  FaBuilding,
  FaShoppingBag,
  FaShoppingCart,
  FaHeart,
  FaTag,
  FaShippingFast,
  FaEye,
  FaStar,
  FaStarHalfAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import ProductCard from "../components/product/ProductCard";
import SocialProof from "../components/Social-Proof";
import Highlight from "../components/Highlight";
import Divider from "../components/Divider";
import MobileApp from "../components/MobileApp";
import FAQ from "../components/Faq";
import { useCart } from "../context/cartContext";
import { useWishlist } from "../context/wishlistContext";
const categoryIcons = {
  fashion: <FaTshirt />,
  electronic: <FaMobileAlt />,
  game: <FaGamepad />,
  "pet shop": <FaPaw />,
  furniture: <FaCouch />,
  vehicle: <FaCar />,
  rent: <FaMoneyBillWave />,
  property: <FaBuilding />,
  "house for rent": <FaHome />,
  accessories: <FaShoppingBag />,
};

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const { addToCart } = useCart();
  const { addToWishlist } = useWishlist();
  const { cartItems } = useCart();

  useEffect(() => {
    console.log("Cart items updated:", cartItems);
  }, [cartItems]);

  const fetchProducts = useCallback(
    async (categoryId = null, subcategoryId = null) => {
      try {
        const url = `https://api.theonlysale.com/api/product/get/`;
        const response = await axios.get(url, {
          params: {
            categoryId,
            subcategoryId,
          },
        });

        // Fetch user statuses based on the user_ids in the products
        const productsWithUserStatus = await Promise.all(
          response.data.slice(0, 12).map(async (product) => {
            let imagesArray = [];
            try {
              imagesArray = JSON.parse(product.images);
            } catch (e) {
              console.error("Error parsing images array:", e);
            }

            const firstImage = imagesArray.length > 0 ? imagesArray[0] : null;

            // Fetch user status for the product's user_id
            let userStatus = null;
            try {
              const userResponse = await axios.get(
                `https://api.theonlysale.com/api/user/get/status/${product.user_id}`
              );
              userStatus = userResponse.data.status;
            } catch (error) {
              console.error(
                `Error fetching user status for user ${product.user_id}:`,
                error
              );
            }

            return {
              ...product,
              imageURI: firstImage
                ? `https://api.theonlysale.com/uploads/images/${firstImage
                    .split(/[\\/]/)
                    .pop()}`
                : null,
              userStatus, // Add the user's status to the product
            };
          })
        );

        // Filter products with "active" user status only
        const activeProducts = productsWithUserStatus.filter(
          (product) => product.userStatus === "active"
        );

        // Sort products: First show products with stock > 0, then show out-of-stock products
        activeProducts.sort((a, b) => (b.stock > 0) - (a.stock > 0));

        // Apply category and subcategory filters if selected
        let updatedProducts = activeProducts;
        if (selectedCategory) {
          updatedProducts = updatedProducts.filter(
            (product) => product.category_id === selectedCategory
          );
        }
        if (selectedSubcategory) {
          updatedProducts = updatedProducts.filter(
            (product) => product.subcategory_id === selectedSubcategory
          );
        }

        setProducts(updatedProducts);
        setFilteredProducts(updatedProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setLoading(false);
      }
    },
    [selectedCategory, selectedSubcategory]
  );

  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, [fetchProducts]);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/categories/get`
      );
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubcategories = async (category_id) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/subcategory/getByCategory/${category_id}`
      );
      setSubcategories(response.data);
      setSelectedCategory(category_id);
      setSelectedSubcategory(null);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleCategoryPress = (category_id) => {
    if (selectedCategory === category_id) {
      setSelectedCategory(null);
      setSelectedSubcategory(null);
      fetchProducts(null, null);
    } else {
      setSelectedCategory(category_id);
      fetchSubcategories(category_id);
      fetchProducts(category_id, null);
    }
  };

  const handleSubcategoryPress = (subcategory_id) => {
    if (selectedSubcategory === subcategory_id) {
      setSelectedSubcategory(null);
      fetchProducts(selectedCategory, null);
    } else {
      setSelectedSubcategory(subcategory_id);
      fetchProducts(selectedCategory, subcategory_id);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProducts();
  }, [fetchProducts]);

  const handleAddToWishlist = (product) => {
    addToWishlist(product);
  };
  useEffect(() => {
    const anonymousId = Cookies.get("anonymousId");
  }, [cartItems]);

  const handleAddToCart = (product) => {
    addToCart(product);
  };
  const scrollRef = useRef(null); // Create a reference for the subcategories div

  const handleScroll = (direction) => {
    const scrollAmount = 200; // Adjust based on how much you want to scroll
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth", // Smooth scroll effect
      });
    }
  };
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <p className="text-lg font-bold text-gray-700 dark:text-gray-200">
          Loading...
        </p>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="mx-auto p-4 bg-white dark:bg-gray-900">
        <Hero />

        <div className="w-full mb-6">
          <div className="flex flex-col sm:flex-row justify-between items-center w-full">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-4 text-[#1D3351] dark:text-gray-100">
              Categories
            </h2>
            <a
              href="/all-categories"
              className="text-base sm:text-lg md:text-xl font-extrabold mb-4 text-[#1D3351] dark:text-gray-100"
            >
              View more
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8">
            {categories.slice(0, 10).map((category) => (
              <div
                key={category.category_id}
                onClick={() => handleCategoryPress(category.category_id)}
                className={`cursor-pointer flex flex-col items-center justify-center transition-all duration-300 transform hover:scale-105 ${
                  selectedCategory === category.category_id
                    ? "text-white"
                    : "text-[#1D3351] dark:text-gray-300"
                }`}
              >
                <div
                  className={`flex items-center justify-center rounded-full transition-colors duration-300 ${
                    selectedCategory === category.category_id
                      ? "bg-blue-500 text-white"
                      : "bg-gray-100 dark:bg-gray-800 text-[#1D3351] dark:text-gray-300 border border-gray-300 dark:border-gray-600"
                  }`}
                  style={{ width: "80px", height: "80px" }} // Increased size
                >
                  <div className="text-2xl sm:text-3xl">
                    {" "}
                    {/* Increased font size */}
                    {categoryIcons[category.name.toLowerCase()] || <FaHome />}
                  </div>
                </div>
                <span
                  className={`text-center mt-3 font-medium text-sm sm:text-base ${
                    // Increased font size and margin
                    selectedCategory === category.category_id
                      ? "text-[#1D3351] dark:text-white"
                      : "text-[#1D3351] dark:text-gray-300"
                  }`}
                >
                  {category.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        {selectedCategory && subcategories.length > 0 && (
          <div className="w-full mb-6">
            {/* Arrows for navigation */}
            <div className="flex justify-between items-center">
              <button
                onClick={() => handleScroll("left")}
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                aria-label="Scroll left"
              >
                {/* Left arrow (could use an icon or emoji) */}
                &#9664;
              </button>

              <div
                ref={scrollRef} // Attach scrollRef to this div
                className="flex overflow-x-auto space-x-6 no-scrollbar" // Flexbox with horizontal scroll
              >
                {subcategories.map((subcategory) => (
                  <div
                    key={subcategory.subcategory_id}
                    onClick={() =>
                      handleSubcategoryPress(subcategory.subcategory_id)
                    }
                    className={`cursor-pointer flex-shrink-0 w-48 sm:w-40 md:w-36 lg:w-48 flex flex-col items-center justify-center p-4 sm:p-3 md:p-2 rounded-lg transition-colors duration-300 transform hover:scale-105 ${
                      selectedSubcategory === subcategory.subcategory_id
                        ? "bg-blue-700 text-white border-blue-900"
                        : "bg-gray-100 text-gray-700 border-gray-300 dark:bg-gray-700 dark:text-gray-300"
                    }`}
                  >
                    <p className="text-lg sm:text-sm md:text-base font-medium">
                      {subcategory.name}
                    </p>
                  </div>
                ))}
              </div>

              <button
                onClick={() => handleScroll("right")}
                className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                aria-label="Scroll right"
              >
                {/* Right arrow (could use an icon or emoji) */}
                &#9654;
              </button>
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row justify-between items-center w-full">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-[#1D3351] dark:text-gray-100">
            Products
          </h1>
          <a
            href="/categories/1"
            className="text-base sm:text-lg md:text-xl font-extrabold mb-4 text-[#1D3351] dark:text-gray-100"
          >
            View more
          </a>
        </div>

        <div className="grid gap-4 grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mb-4 md:mb-8">
          {filteredProducts.length === 0 ? (
            <div className="col-span-full text-center text-base sm:text-lg font-semibold text-[#1D3351] dark:text-gray-200">
              No products available.
            </div>
          ) : (
            filteredProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                handleAddToWishlist={handleAddToWishlist}
                handleAddToCart={handleAddToCart}
              />
            ))
          )}
        </div>
      </div>

      <Divider />
      <Highlight />
      <Divider />
      <SocialProof />
      <Divider />
      <MobileApp />
      <Footer />
    </>
  );
};
export default Home;
